import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import withStyles from "components/with-styles";
import styles from "../styles/source-data.css.js";
import { SecondCoachButtonWithModal } from "components/buttons";
import cn from "classnames";
import Chip from "components/chip";
import { SimpleButton } from "components/buttons";
import {
  ROLE_PARTNER_USER,
  ROLE_SUPER_USER,
  SOURCE_FUNCTION_STATE_DISABLED,
  SOURCE_FUNCTION_STATE_ENABLED,
  SOURCE_FUNCTION_TYPE_ACTIVATE,
  SOURCE_FUNCTION_TYPE_DEACTIVATE,
  SOURCE_ICON_TYPE_CHECK,
  SOURCE_ICON_TYPE_CLOSE,
} from "../../../../utils/constants";
import RestrictedToAdmin from "../../../../components/auth/restricted/restricted-to-admin";

const SecondCoachData = ({
  classes,
  source,
  intl,
  actionShowModalConfirmationSecondCoach = () => {},
  secondCoachUrlEnabled,
}) => {
  const ONLY_ROL_SUPER_AND_PARTNER = [ROLE_SUPER_USER, ROLE_PARTNER_USER];
  const [secondCoachUrl, setSecondCoachUrl] = useState(source.publicInterface.secondCoachUrl);

  useEffect(
    () => {
      if (source.publicInterface.secondCoachUrl) {
        setSecondCoachUrl(source.publicInterface.secondCoachUrl);
      }
    },
    [source],
  );

  const onChangeSecondCoach = () => {
    actionShowModalConfirmationSecondCoach();
  };

  return (
    <DataGridItem big title={intl.formatMessage({ id: "source.interface.secondCoach" })}>
      <div style={{ display: "flex" }}>
        <Chip
          className={cn(classes.chip, classes.chip_secondCoach, { secondCoachUrl: classes.chip__activated })}
          variant="outlined"
          label={intl.formatMessage({
            id: `source.secondCoach.${secondCoachUrl ? SOURCE_FUNCTION_STATE_ENABLED : SOURCE_FUNCTION_STATE_DISABLED}`,
          })}
        />
        {secondCoachUrlEnabled && (
          <DataGridItem>
            <SimpleButton
              onClick={onChangeSecondCoach}
              className={classes.chipButton}
              icon={secondCoachUrlEnabled ? SOURCE_ICON_TYPE_CLOSE : SOURCE_ICON_TYPE_CHECK}
              label={intl.formatMessage({
                id: `source.secondCoach.${
                  secondCoachUrlEnabled ? SOURCE_FUNCTION_TYPE_DEACTIVATE : SOURCE_FUNCTION_TYPE_ACTIVATE
                }`,
              })}
            />
          </DataGridItem>
        )}
        {source.publicInterface && (
          <RestrictedToAdmin>
            <SecondCoachButtonWithModal secondCoachUrl={secondCoachUrl} />
          </RestrictedToAdmin>
        )}
      </div>
    </DataGridItem>
  );
};

SecondCoachData.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
};

export default injectIntl(withStyles(styles)(SecondCoachData));
